<template>
  <div class="order finDetails">
    <head-panel title="财务管理" subtitle="FINANCIAL MANAGEMENT" :exportUrl="financial.detailsDown"></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">财务明细</h3>
      <ny-date-range @change="dateChange" :shortcut="true" class="el-date-editor" :v-model="date"></ny-date-range>
      <div class="selectBox clearfix">
        <ny-select
          :data="financial.detailsTypeMenu"
          v-model="financial.curDetailsType"
          :keyValue="['value', 'name']"
          @changeSelectMenu="changeSelect"
          type="detailsType"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <el-button class="oprSuccess mr55" @click="searchData">搜索</el-button>
      </div>
      <div class="adTable">
        <ny-table
          class="tableBox mt20"
          :page="financial.detailsPage"
          :pageFalse="true"
          @size-change="changePageSize"
          @current-change="changePageSize"
          v-loading="loading"
        ></ny-table>
      </div>
    </div>
  </div>
</template>

<script>
import { headPanel, NySelect, NyTable, NyDateRange } from '@/global/components';
import { mapGetters } from 'vuex';
export default {
  name: 'advertiser',
  data () {
    return {
      adver: '',
      downloadExc: '',
      date: [],
      startTime: '',
      endTime: '',
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.$store.dispatch('finance/getFinDetailsTypeMenu', { userType: 4 })
      this.getFinDetailsInfo()
    },
    getFinDetailsInfo ({ currentPage, pageSize } = {}) {
      this.$store.dispatch('finance/getFinDetailsTable', {
        currentPage,
        pageSize,
        userId: this.userid,
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.financial.curDetailsType
      })
    },
    changeSelect ({ value, type }) {
      // if (type === 'userType') {
      // }
    },
    changePageSize ({ currentPage, pageSize } = {}) {
      this.getFinDetailsInfo({ currentPage, pageSize })
    },
    handleClick (val) {
    },
    disDate (time) {
      return new Date(time) > Date.now();
    },
    dateChange (date) {
      this.startTime = date[0]
      this.endTime = date[1]
    },
    searchData () {
      this.financial.detailsPage.resetData()
      this.getFinDetailsInfo()
    }
  },
  components: {
    headPanel,
    NySelect,
    NyTable,
    NyDateRange
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.finDetails {
  .el-date-editor {
    margin-left: 20px;
    margin-top: 20px;
  }
  .selectBox {
    margin-top: 20px;
    .el-select {
      width: 230px;
    }
  }
}
</style>
